// @flow

const getGravatarUrl = (emailHash: ?string) =>
  emailHash
    ? `https://secure.gravatar.com/avatar/${emailHash}.jpg?s=128&d=404`
    : // From https://en.gravatar.com/site/implement/images/
      // All of our user icons use gravatar which is why I'm
      // hardcoding this here.
      'https://www.gravatar.com/avatar/?d=mm';

export default getGravatarUrl;
